"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.definePinoLogHandlers = void 0;
var _SeverityLevels = require("../../types/SeverityLevels");
const definePinoLogHandlers = handlers => message => {
  switch (message.level) {
    case _SeverityLevels.SeverityLevels.INFO:
      handlers.onInfo?.(message);
      break;
    case _SeverityLevels.SeverityLevels.METRIC:
      handlers.onMetric?.(message);
      break;
    case _SeverityLevels.SeverityLevels.ERROR:
      handlers.onError?.(message);
      break;
    case _SeverityLevels.SeverityLevels.WARN:
      handlers.onWarn?.(message);
      break;
    case _SeverityLevels.SeverityLevels.DEBUG:
      handlers.onDebug?.(message);
      break;
    default:
      // eslint-disable-next-line no-console -- it's okay here
      console.warn(`Unknown message level: ${message.level}`);
  }
};
exports.definePinoLogHandlers = definePinoLogHandlers;
